"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandingService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var Profile_service_1 = require("../services/Profile.service");
var BlobStorageApi_service_1 = require("../services/BlobStorageApi.service");
var SystemOptions_service_1 = require("../services/SystemOptions.service");
var colorUtil_1 = require("../util/colorUtil");
var BrandingService = /** @class */ (function () {
    function BrandingService(profileService, systemOptionsService, blobStorageApiService) {
        this.profileService = profileService;
        this.systemOptionsService = systemOptionsService;
        this.blobStorageApiService = blobStorageApiService;
        this.updateColorAlpha = colorUtil_1.updateColorAlpha;
    }
    /**
     * Get raw branding info according to the current profile info
     * @returns raw info
     */
    BrandingService.prototype.getRawCurrentProfileBranding = function () {
        var profile = this.profileService.getCurrentProfile();
        return (profile && {
            PrimaryHighLightColor: profile === null || profile === void 0 ? void 0 : profile.PrimiryHighLightColor,
            SecondaryHighLightColor: profile === null || profile === void 0 ? void 0 : profile.SecondryHighLightColor,
            LogoBlobId: profile === null || profile === void 0 ? void 0 : profile.LogoBlobId,
            LogoUrl: profile === null || profile === void 0 ? void 0 : profile.LogoUrl,
        });
    };
    /**
     * Get branding info according to the current profile info
     * @returns colors in rgba(r,g,b,a) format
     */
    BrandingService.prototype.getCurrentProfileBranding = function () {
        return __awaiter(this, void 0, void 0, function () {
            var branding, staticBranding, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        branding = this.getRawCurrentProfileBranding();
                        staticBranding = this.getStaticBranding();
                        if (!branding) {
                            return [2 /*return*/, staticBranding];
                        }
                        _c = {};
                        _a = branding.LogoUrl;
                        if (_a) return [3 /*break*/, 3];
                        _b = branding.LogoBlobId;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.blobStorageApiService.getImageUrl(branding.LogoBlobId)];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        _a = (_b);
                        _d.label = 3;
                    case 3: return [2 /*return*/, (_c.logo = _a,
                            _c.primaryColor = colorUtil_1.safeArgb2Rgba(branding.PrimaryHighLightColor, 'currentProfile.PrimiryHighLightColor is not in format of #FFFFFF or #FFFFFFFF, received: ' +
                                branding.PrimaryHighLightColor) || staticBranding.primaryColor,
                            _c.secondaryColor = colorUtil_1.safeArgb2Rgba(branding.SecondaryHighLightColor, 'currentProfile.SecondryHighLightColor is not in format of #FFFFFF or #FFFFFFFF, received: ' +
                                branding.SecondaryHighLightColor) || staticBranding.secondaryColor,
                            _c)];
                }
            });
        });
    };
    /**
     * Get raw system setting branding info
     * @returns raw info
     */
    BrandingService.prototype.getRawGlobalBranding = function () {
        return __awaiter(this, void 0, void 0, function () {
            var globalBranding;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.systemOptionsService.getSystemOption('GlobalBrandSetting')];
                    case 1:
                        globalBranding = _a.sent();
                        return [2 /*return*/, globalBranding];
                }
            });
        });
    };
    /**
     * Get system setting branding info
     * @returns colors in rgba(r,g,b,a) format
     */
    BrandingService.prototype.getGlobalBranding = function () {
        return __awaiter(this, void 0, void 0, function () {
            var globalBranding, staticBranding, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getRawGlobalBranding()];
                    case 1:
                        globalBranding = _c.sent();
                        staticBranding = this.getStaticBranding();
                        _b = {};
                        _a = globalBranding.ThumbnailRelativePathWithSignature;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.blobStorageApiService.getFitImageURL(globalBranding.ThumbnailRelativePathWithSignature, 'Large')];
                    case 2:
                        _a = (_c.sent());
                        _c.label = 3;
                    case 3: return [2 /*return*/, (_b.logo = (_a) ||
                            staticBranding.logo,
                            _b.primaryColor = colorUtil_1.safeArgb2Rgba(globalBranding.ThemeColor.PrimaryColor, 'GlobalBrandSetting.ThemeColor.PrimaryColor is not in format of #FFFFFF or #FFFFFFFF, received: ' +
                                globalBranding.ThemeColor.PrimaryColor) || staticBranding.primaryColor,
                            _b.secondaryColor = colorUtil_1.safeArgb2Rgba(globalBranding.ThemeColor.SecondaryColor, 'GlobalBrandSetting.ThemeColor.SecondaryColor is not in format of #FFFFFF or #FFFFFFFF, received: ' +
                                globalBranding.ThemeColor.SecondaryColor) || staticBranding.secondaryColor,
                            _b)];
                }
            });
        });
    };
    /**
     * Get hardcoded branding info
     * @returns colors in rgba(r,g,b,a) format
     */
    BrandingService.prototype.getStaticBranding = function () {
        return {
            logo: '',
            primaryColor: colorUtil_1.safeArgb2Rgba('#DB3B0A', null),
            secondaryColor: colorUtil_1.safeArgb2Rgba('#729BA3', null),
        };
    };
    BrandingService.updateColorAlpha = colorUtil_1.updateColorAlpha;
    BrandingService = __decorate([
        CommonService_decorator_1.CommonService('BrandingService'),
        __metadata("design:paramtypes", [Profile_service_1.ProfileService,
            SystemOptions_service_1.SystemOptionsService,
            BlobStorageApi_service_1.BlobStorageApiService])
    ], BrandingService);
    return BrandingService;
}());
exports.BrandingService = BrandingService;
//# sourceMappingURL=Branding.service.js.map